import qs from 'qs';

import { ROUTES } from 'components/Estimate/common/routes';
import url from 'components/url';

import { generateQueryString } from './ParameterUtilities';

export default class RedirectTo {
  static system_status() {
    window.location = 'https://status.housecallpro.com/';
  }

  static signupWhenLoginNotFound() {
    window.location = `${HOUSECALLPRO_URL}/signup?loginNotFound=true`;
  }

  static job(id) {
    window.location = `/pro/jobs/${id}`;
  }

  static jobWithScheduleDialogOpen(id) {
    window.location = `/pro/jobs/${id}?schedule-open=true`;
  }

  static proposal(id) {
    window.location = `/pro/proposals/${id}`;
  }

  static proposalsList() {
    window.location = `/pro/proposals`;
  }

  static addProposal() {
    window.location = '/pro/proposals/new';
  }

  static estimate(id) {
    window.location = `/pro/estimates/${id}`;
  }

  static event(id) {
    window.location = `/pro/events/${id}`;
  }

  static appsBase() {
    window.location = `/pro/apps`;
  }

  static appsDetails(app) {
    window.location = `/pro/apps/details/${app}`;
  }

  static customers() {
    window.location = '/pro/customers';
  }

  static customer(id) {
    window.location = `/pro/customers/${id}`;
  }

  static payouts() {
    window.location = '/pro/my_money';
  }

  static accountNoAccess() {
    window.location = '/pro/account/no_access';
  }

  static billing() {
    window.location = '/pro/account/billing';
  }

  static billingWithPaywall() {
    window.location = '/pro/account/billing?select-plan=true';
  }

  static onlineBooking() {
    window.location = '/pro/apps#online-booking';
  }

  static onlineBookingDetails() {
    window.location = '/pro/apps/details/online_booking';
  }

  static addJob() {
    window.location = '/pro/jobs/new';
  }

  static addEstimate(virtual = false, queryString = '') {
    if (virtual) {
      window.location = `/pro/estimates/new?virtual=true`;
    } else {
      window.location = `/pro/estimates/new${queryString}`;
    }
  }

  static addEvent() {
    window.location = '/pro/new_event';
  }

  static CsvOrGoogleImport() {
    window.location = '/pro/customers?csv-or-google-import=true';
  }

  static importCsvPriceList() {
    window.location = '/pro/account/price_list?import-csv=true';
  }

  static addServiceItem() {
    window.location = '/pro/account/price_list?add-service=true';
  }

  static priceList() {
    window.location = '/pro/account/price_list';
  }

  static googleAuth() {
    window.location = '/pro/google/auth';
  }

  static dashboard() {
    window.location = '/pro/dashboard';
  }

  static estimateTemplates() {
    window.location = `/app/price_book${ROUTES.ESTIMATE_TEMPLATES}`;
  }

  static lemonadeSetup() {
    window.location = '/pro/setup/';
  }

  static myMoney() {
    window.location = '/pro/my_money';
  }

  static openInvoices(filters = null) {
    window.location = `/pro/reports/open_invoices${filters ? `?${filters}` : ''}`;
  }

  static serviceAgreements() {
    window.location = '/app/service_agreements/';
  }

  static servicePlanVisits(filters = null) {
    const queryString = generateQueryString(filters);
    window.location = `/app/service_agreements/visits?${queryString}`;
  }

  static customerServiceAgreements(csaUuid) {
    window.location = `/app/customer_service_agreements/${csaUuid}`;
  }

  static callRail() {
    window.location = '/pro/integrations/call_rail';
  }

  static referral() {
    window.location = '/pro/account/referrals';
  }

  static reviews() {
    window.location = '/pro/apps/reviews';
  }

  static facebookLogin() {
    window.location = `/auth/facebook`;
  }

  static mailchimpLogin() {
    window.location = '/auth/mailchimp';
  }

  static mailchimp() {
    window.location = '/pro/integrations/mailchimp';
  }

  static pro() {
    window.location = '/pro';
  }

  static equipment(id) {
    window.location = `/app/equipment/${id}`;
  }

  static checklists() {
    window.location = '/app/checklist_templates';
  }

  static virtualEstimates() {
    window.location = '/pro/apps/details/virtual_estimate';
  }

  static betaWaitlist() {
    window.location = 'https://housecall.typeform.com/to/Qpn3MM';
  }

  static qboErrors(invoiceNumber) {
    if (invoiceNumber) {
      const filter = generateQueryString({ invoice_number: invoiceNumber });
      window.location = `/app/quickbooks_online/errors?${filter}`;
    } else {
      window.location = '/app/quickbooks_online/errors';
    }
  }

  static qboSettingsSyncAlerts(invoiceNumber) {
    if (invoiceNumber) {
      const filter = generateQueryString({ invoice_number: invoiceNumber });
      window.location = `/pro/account/quickbooks_online/sync_alerts?${filter}`;
    } else {
      window.location = '/pro/account/quickbooks_online/sync_alerts';
    }
  }

  static qbdErrors(invoice_number) {
    const query_string = qs.stringify({ invoice_number });
    if (invoice_number) {
      window.location = `/app/quickbooks_desktop/errors?${query_string}`;
    } else {
      window.location = '/app/quickbooks_desktop/errors';
    }
  }

  static qboOnboarding() {
    window.location = '/app/quickbooks_online/onboarding';
  }

  static qbdOnboarding() {
    window.location = '/app/quickbooks_desktop/onboarding';
  }

  static reporting(orgUuid) {
    window.location = `${PRO_DASHBOARD_BASE_URL}/index.html?uuid=${orgUuid}`;
  }

  static mailchimpAppPage() {
    window.location = `${HOUSECALL_URL}/pro/apps/details/mailchimp`;
  }

  static equipmentTable() {
    window.location = '/app/equipment';
  }

  static customFields() {
    window.location = '/app/job_fields';
  }

  static vendors(origin = null) {
    if (origin) {
      const queryString = generateQueryString({ origin });

      window.location = `/app/vendors?${queryString}`;
    } else {
      window.location = `/app/vendors`;
    }
  }

  static purchaseOrder(id) {
    window.location = `/app/purchase_orders/${id}`;
  }

  static purchaseOrderConfirmation(id) {
    window.location = `/app/purchase_orders/${id}/confirmation`;
  }

  static purchaseOrderCart(id) {
    window.location = `/app/purchase_orders/${id}/cart`;
  }

  static connectToCarrier(origin) {
    window.location = `/auth/carrier_enterprise?origin=${origin}`;
  }

  static welcome() {
    window.location = '/pro/setup/welcome';
  }

  static scheduleAndDispatch() {
    window.location = '/pro/jobs/first_time_use/introduction';
  }

  static sendInvoices() {
    window.location = '/pro/jobs/invoice/introduction';
  }

  static estimatesFirstTimeUse() {
    window.location = '/pro/estimates/first_time_use/introduction';
  }

  static getReviews() {
    window.location = '/pro/apps/reviews/introduction';
  }

  static priceBook() {
    window.location = '/app/price_book';
  }

  static map() {
    window.location = `/pro/map`;
  }

  static getStarted() {
    window.location = '/app/get_started';
  }

  static getStartedSurvey() {
    window.location = '/app/get_started_survey';
  }

  static jobPerformanceDrillDown(subRoute, queryString) {
    window.location = `/app/reporting/jobs/${subRoute}?${queryString}`;
  }

  static jobFields() {
    window.location = '/pro/account/job_details/job_fields';
  }

  static jobCosting() {
    window.location = '/pro/account/job_details/job_costing';
  }

  static TimeTracking() {
    window.location = '/pro/account/time_tracking';
  }

  static newLead() {
    window.location = url.leads.path;
  }

  static accountSettings(subRoute = null) {
    if (subRoute) {
      window.location = `/pro/account/${subRoute}`;
    } else {
      window.location = '/pro/account';
    }
  }

  static helpCenter() {
    return window.open('http://help.housecallpro.com/', '_blank');
  }

  static helpCenterForHowToCreateAJob() {
    return window.open('https://help.housecallpro.com/en/articles/3181752-how-to-create-a-job', '_blank');
  }

  static helpCenterForSendEmployeeInvitationWeb() {
    return window.open('https://help.housecallpro.com/en/collections/74776-employees', '_blank');
  }

  static setYourPassword() {
    window.location = '/pro/account/set-your-password';
  }

  static dataImportIntroduction() {
    window.location = '/app/data_import/introduction';
  }

  static customReports() {
    window.location = '/app/reporting/custom';
  }

  static doYouUseQuickBooksPage() {
    window.location = '/app/data_import/imports/new/use_quickbooks';
  }

  static productTour() {
    window.location = '/app/product_tour';
  }

  static myAccount() {
    window.location = '/pro/account/employees/my_account';
  }

  static appSettings(path) {
    window.location = `${url.settings.appPath}/${path}`;
  }

  static onlineBookingSettings(onboardingFinished = false) {
    window.location = `${url.settings.appPath}/online_booking/settings/available_services${
      onboardingFinished ? '?onboardingFinished=true' : ''
    }`;
  }
}
